import {Lottie} from "lottie-react";
import {useTranslation} from "react-i18next";
import emptyAnimationEn from "../../../animations/emptyProposition.json";
import {withoutEmbeddedEmptyStateCopy} from "../../../utils/emptyAnimation";

const emptyAnimation = withoutEmbeddedEmptyStateCopy(emptyAnimationEn);

const EmptyState = ({className = "", animationClassName = ""}) => {
  const {t} = useTranslation();

  return (
    <div
      className={`flex flex-col items-center justify-center ${className}`}
      role="status"
      aria-label={t("noDataFound")}
    >
      <div className={`relative w-full max-w-[280px] aspect-square ${animationClassName}`}>
        <Lottie
          src={emptyAnimation}
          autoplay
          loop
        />
        <div className="pointer-events-none absolute left-[18%] top-[18%] min-w-[58%] max-w-[72%] -rotate-6 rounded-md bg-[#FF6600] px-[7%] py-[4%] text-center text-sm font-semibold text-white">
          {t("noDataFound")}
          <span className="absolute -bottom-3 left-[42%] h-0 w-0 border-l-[5px] border-r-[15px] border-t-[14px] border-l-transparent border-r-transparent border-t-[#FF6600]" />
        </div>
      </div>
      <p className="mt-2 text-center text-slate-500">{t("noDataFound")}</p>
    </div>
  );
};

export default EmptyState;
